/*
 * Language-switch path preservation for metaobject custom-URL pages.
 *
 * Problem: metaobject pages (perfumer, fragrance_notes) render at custom URLs
 * like /pages/perfumers/<handle>. Dawn's {% form 'localization' %} POSTs to
 * /localization and redirects to the form's return_to, but Shopify computes
 * that return_to from the server-side request path, which for a metaobject
 * custom URL drops the handle. The switch then lands on the parent page
 * (/<locale>/pages/perfumers).
 *
 * Metaobject handles are NOT translated per locale, so the path is identical in
 * every locale and we can rebuild it from window.location.
 *
 * Two cases:
 *   - Prefixed locale (root_url like /en, /ar): the URL prefix alone forces the
 *     locale, so navigate straight to <root><path>. No form, no cookie needed.
 *   - Default locale (root_url == /): there is no prefix to signal the locale,
 *     so we MUST go through the localization form for Shopify to flip the active
 *     locale. We only override return_to with the full path so the handle
 *     survives, then let Dawn submit the form.
 *
 * Scoped to metaobject templates only (see layout/theme.liquid). Other page
 * types may have translated URL handles, where Dawn's resource-aware redirect
 * is still required, so this must NOT run globally.
 */
(function () {
  var SELECTOR = 'a.js-language-link[data-root-url]';

  // Current path relative to the active locale (locale prefix removed), so it
  // can be re-prefixed for any target locale. Includes the query string.
  function localeRelativePath() {
    var currentRoot = '/';
    var active = document.querySelector(SELECTOR + '[aria-current="true"]');
    if (active) currentRoot = active.getAttribute('data-root-url') || '/';

    var path = window.location.pathname;
    if (currentRoot !== '/' && path.indexOf(currentRoot) === 0) {
      path = path.slice(currentRoot.length) || '/';
      if (path.charAt(0) !== '/') path = '/' + path;
    }
    return path + (window.location.search || '');
  }

  // Capture on document so this runs before the <localization-form> element's
  // own click handler.
  function onClickCapture(event) {
    var target = event.target;
    var link = target && target.closest ? target.closest(SELECTOR) : null;
    if (!link) return;

    var root = link.getAttribute('data-root-url') || '/';
    var rel = localeRelativePath();

    if (root !== '/') {
      // Prefixed locale: the prefix forces the locale, navigate directly and
      // keep the full path (including the metaobject handle).
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(root.replace(/\/+$/, '') + rel);
      return;
    }

    // Default (no-prefix) locale: the form switches the active locale via a
    // cookie, but Shopify strips the metaobject handle from return_to, so a
    // plain submit lands on the parent page. Instead POST the form ourselves
    // (sets the cookie, carries the authenticity token), then navigate to the
    // full path. The cookie makes the no-prefix root render the chosen locale.
    var form = link.closest('form');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();

    var body = new FormData(form);
    body.set('locale_code', link.getAttribute('data-value'));
    body.set('return_to', rel);

    var go = function () {
      window.location.assign(rel);
    };
    fetch(form.action, { method: 'POST', body: body, credentials: 'same-origin' }).then(go, go);
  }

  document.addEventListener('click', onClickCapture, true);
})();
